/**
 * Canonical text primitive for the post-NativeBase UI boundary.
 *
 * New or modified UI should import `Typography` from `components/ui`, not from the
 * deep `ucl/components/text/Typography` path and not from the `@rbilabs/universal-components`
 * barrel. This re-export is the single sanctioned bridge into the legacy UCL layer while the
 * underlying native primitive still lives there — it adds no behavior, so RN/Web prop
 * sanitization stays at the existing boundary.
 *
 * Do NOT copy this UCL import into other `components/ui` files; see
 * `docs/ui/nativebase-migration-guide.md` for the dependency-direction rule.
 */
export { Typography, withTypography } from 'ucl/components/text/Typography';
export type { TypographyProps } from 'ucl/components/text/Typography';
